<template>
  <v-layout column wrap>
    <v-flex>
      <span class="headline">
        Efectividad
      </span>
    </v-flex>
    <v-flex class="mt-1">
      <v-container grid-list-md>
        <v-layout row>
          <v-flex v-for="(pie, i) in data"
            :key="`efectivity-pie-${i}`" 
            @click="showModal(pie.title, i)"
            class="text-xs-center card--hover md3">
            <div class="bordered">
              <transition name="fade-effect" mode="out-in">
                <template v-if="isSearching || internalStep < (i + 1) || step < initiate">
                  <skeleton-box flat>
                    <skeleton-avatar class="avatar-skeleton-custom" size="15vh"></skeleton-avatar>
                  </skeleton-box>
                </template>
                <template v-else>
                  <div>
                    <span class="d-block body-2">
                      {{pie.title}}
                    </span>
                    <template v-if="checkData(pie.data)">
                      <span class="d-block caption">
                        {{new Intl.NumberFormat('es-VE').format(pie.total)}}
                      </span>
                      <pie @update-internal-step="$emit('update-internal-step', (i + 2))" 
                        :data="pie.data" :color="pie.color"/>
                    </template>
                    <v-layout v-else 
                      style="height: 112px!important;" 
                      class="align-center text-xs-center">
                      <v-flex>
                        <span>
                          No hay información
                        </span>
                      </v-flex>
                    </v-layout>
                  </div>
                </template>
              </transition>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
    <info-modal
      :identifier="type"
      :filters="filters"
      :titleStatus="name"
      :show="dialog"
      v-if="dialog"
      @change-value="dialog = $event"/>
  </v-layout>
</template>
<script>
import SkeletonAvatar from '@/components/global/skeletons/Avatar';
import SkeletonBox from '@/components/global/skeletons/SkeletonBox';
import Pie from './Pie';
import infoModal from './InfoModal';

export default {
  props: {
    internalStep: {
      type: Number,
      default: 0,
    },
    initiate: {
      type: Number,
      default: 0,
    },
    step: {
      type: Number,
      default: 0,
    },
    isSearching: {
      type: Boolean,
      default: 0,
    },
    data: {
      type: Array,
      default: () => [],
    },
    filters: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    Pie,
    infoModal,
    SkeletonBox,
    SkeletonAvatar,
  },
  data() {
    return {
      dialog: false,
      name: '',
      type: 0,
    };
  },
  methods: {
    checkData(data) {
      if (data[0].value > 0 || data[1].value > 0) {
        return true;
      }
      return false;
    },
    showModal(title, id) {
      this.name = title;
      this.type = id;
      this.dialog = true;
    },
  },
  watch: {
    internalStep: {
      handler(value) {
        // eslint-disable-next-line
        if (this.data[value - 1] && !this.checkData(this.data[value - 1].data) && this.initiate <= this.step) {
          this.$emit('update-internal-step', this.internalStep + 1);
        }
      },
    },
  },
};
</script>
<style scoped>
.avatar-skeleton-custom {
  width: 15vh;
  height: 15vh;
  margin-left: auto;
  margin-right: auto;
  margin-top: 7vh;
}
</style>





// WEBPACK FOOTER //
// src/components/panelV2/Channels/PieLine/Efectivity.vue